'use strict';

import { debounce, isMobile, easeOutExpo } from '../../_js/common/_util';

export default class Header {
    constructor() {
        const self = this;

        self.isMobileDevice = false;
        self.lastScrollTop = 0;

        $(window).on('resize scroll', debounce(self.toggleHeader, 250));

        // $('.-js-close-banner').on('click', function (e) {
        //     e.preventDefault();

        //     $(this).parent().slideUp(easeOutExpo);
        //     $('body').removeClass('-hasNewUpdate');
        // });
    }

    toggleHeader() {
        let self = this;
        let $header = $('header');
        let $view = $('.view');
        let st = $(this).scrollTop();

        self.isMobileDevice = isMobile();

        if (st > self.lastScrollTop) {
            $header.addClass('-hide');
            $view.addClass('-hide');
        } else {
            $header.removeClass('-hide');
            $view.removeClass('-hide');
        }

        //if user has scrolled down
        if (st > 0) {
            $header.addClass('-show-background');
            $view.addClass('-show-background');
        } else {
            $header.removeClass('-show-background');
            $view.removeClass('-show-background');
        }

        self.lastScrollTop = st;
    }
}
